<template>
  <GridBase our-data>
    <h2><TextBlock file="about/our-data-title" class="pre-line"/></h2>
    <TextBlock file="about/our-data-t1" class="pre-line"/>
    <PrExpand id="our-data-v0" title="What is DATA?" :video="`${videoBase}/our-data-01.mp4`" class="j" data-offset="0">
      <TextBlock file="about/our-data-t2" data-p="0.2,1" data-y="100,0" data-a="0,1" class="pre-line"/>
    </PrExpand>

    <section class="sec1 j" data-offset="100">
      <div class="imgs">
        <ul>
          <li>
            <img src="/img/about/data/data-s1-cont-1.s.jpg" alt="" class="hidden-md-up">
            <img src="/img/about/data/data-s1-cont-1.jpg" alt="" class="hidden-sm-down">
            <p class="tg">They shop with online payment</p>
          </li>
          <li>
            <video :src="`${videoBase}/our-data-02.sm.mp4`" muted autoplay loop playsinline class="hidden-md-up"/>
            <video :src="`${videoBase}/our-data-02.mp4`" muted autoplay loop playsinline class="hidden-sm-down"/>
            <p class="tg">share text, photos, and videos,</p>
          </li>
          <li>
            <video :src="`${videoBase}/our-data-03.mp4`" muted autoplay loop playsinline />
            <p class="tg">check out the weather and traffic information,</p>
          </li>
          <li>
            <img src="/img/about/data/data-s1-cont-4.s.jpg" alt="" class="hidden-md-up">
            <img src="/img/about/data/data-s1-cont-4.jpg" alt="" class="hidden-sm-down">
            <p class="tg">and search for business information.</p>
          </li>
        </ul>
      </div>
      <div class="text">
        <h4 data-p="0.2,1" data-y="100,0" data-a="0,1">
          <template>Significance of <br class="hidden-lg-up">data in daily life</template>
        </h4>
        <TextBlock file="about/our-data-t3" data-p="0.2,1" data-y="100,0" data-a="0,1" class="pre-line"/>
      </div>
    </section>

    <PrExpand title="Data Road" img="/img/about/data/data-s2-img.s.jpg" v-if="sect === 'sm'">
      <h4 data-p="0.4,0.8" data-y="100,0" data-a="0,1">
        <template>Where is <br class="hidden-lg-up">the data going?</template>
      </h4>
      <TextBlock file="about/our-data-t4" data-p="0.7,1" data-y="100,0" data-a="0,1" class="pre-line"/>
    </PrExpand>
    <PrFill v-else title="Data Road" img="/img/about/data/data-s2-title.jpg" class="sec2-title j"/>

    <section class="sec2 j" data-offset="100">
      <div v-if="sect !== 'sm'">
        <h4>
          <template>Where is <br class="hidden-lg-up">the data going?</template>
        </h4>
        <TextBlock class="pre-line" file="about/our-data-t4"/>
      </div>
      <div>
        <div class="img"></div>
        <TextBlock class="pre-line" file="about/our-data-t5"/>
      </div>
    </section>

    <section class="sec3 j">
      <h3 class="q">Data Age</h3>
      <div class="cont">
        <div class="cont-item">
          <GridBase half alpha50 class="img q"/>
          <div>
            <h4>21st century's <br class="hidden-md-up">crude oil, data</h4>
            <TextBlock file="about/our-data-t6" class="pre-line"/>
          </div>
        </div>
        <div class="cont-item">
          <GridBase half alpha50 class="img q"/>
          <div>
            <h4>Preparations for <br class="hidden-lg-up">the data age</h4>
            <TextBlock file="about/our-data-t7" class="pre-line"/>
          </div>
        </div>
      </div>
    </section>

    <section class="sec4">
      <PrHoldOrNotSlide img="/img/about/data/data-s4-img.l.jpg" 
      title="Our data protected by our own technology" desc="Data is a key asset to ensure competitiveness of not just individuals, but of our region, society, and country. Protecting data that is our precious asset, 'data sovereignty' is a critical challenge in the data age. DATA CENTER GAK promises to protect our data with our own technology with a sense of responsibility." subTitle="Promises of DATA CENTER GAK" direction="" mobile-height="375">
        <div class="wrap" v-if="this.sect === 'sm' || this.sect === 'md'">
          <div class="copy">
            <div class="text1" ref="text1">
              <h4><TextBlock file="about/our-data-title2" class="pre-line"/></h4>
              <TextBlock file="about/our-data-t8" class="pre-line"/>
            </div>
            <div class="text2" ref="text2">
              <h4>Promises of <br />DATA CENTER GAK</h4>
            </div>
          </div>
          <div class="scroll">
            <CardItem class="scroll-area" ref="scroll-area">
              <ul class="list">
                <li class="item" v-for="(item) in dataListEN" :key="item.title">
                  <p class="title" v-html="item.title" />
                  <div class="exp">
                    <p class="desc" v-html="item.desc" />
                  </div>
                </li>
              </ul>
            </CardItem>
          </div>
        </div>
        <template v-slot:holdLeft>
          <div id="sec4">
            <div class="wrap">
              <div class="scroll">
                <CardItem class="scroll-area" ref="scroll-area">
                  <ul class="list">
                    <li class="item" v-for="(item) in dataListEN" :key="item.title">
                      <p class="title" v-html="item.title" />
                      <div class="exp">
                        <p class="desc" v-html="item.desc" />
                      </div>
                    </li>
                  </ul>
                </CardItem>
              </div>
            </div>
          </div>
        </template>
      </PrHoldOrNotSlide>
    </section>
    
    <grid-base alpha50 class="cont2" in-only>
      <TextBlock class="pre-line" file="about/our-data-t9" in-only/>
    </grid-base>

    <quick-link>
      <quick-link-item><router-link to="our-idea">Our Idea</router-link></quick-link-item>
      <quick-link-item><router-link to="/gak/gak-sejong">GAK <br class="hidden-md-up">Sejong</router-link></quick-link-item>
    </quick-link>
  </GridBase>
</template>
<script>
import GridBase from '../../components/GridBase';
import QuickLink from '@/views/components/QuickLink';
import QuickLinkItem from '@/views/components/QuickLinkItem';
import TextBlock from '@/views/components/TextBlock';
import PrExpand from '@/views/components/PrExpand';
import PrFill from '@/views/components/PrFill';
import PrHoldOrNotSlide from '@/views/components/PrHoldOrNotSlide';
import CardItem from '@/views/components/CardItem.vue';
import dataListEN from "@/data/data/dataFeatureEN";
import responsive from "@/utils/responsive";
import { applyRatio, getOffsetTop } from "@/utils";
export default {
  name: 'our-data',
  components: { PrFill, PrExpand, TextBlock, QuickLinkItem, QuickLink, GridBase, CardItem, PrHoldOrNotSlide },
  props: {
    img: { type: String, default: `/img/about/data/data-s4-img.l.jpg` },
  },
  data() {
    return {
      dataListEN,
      preScrollTop: 0,
      space: 0,
      push: 0,
      mid: "10000000px",
      fw: "100vw",
      resize: false,
    }
  },
  mounted() {
    this.setElement();
    responsive.addListener(this.resized);
  },
  watch: {
    sv: "render",
  },
  methods: {
    inner(r) {
      applyRatio(this.innerList, r);
    },
    render() {
      if (!this.$el) return;
      this.fw = this.$el.offsetWidth + "px";
      if (this.onFix) {
        applyRatio(0);
        return;
      }
      const sv = this.sv;
      let d = getOffsetTop(this.$el) - sv;
      const h = window.innerHeight;
      if (d < 0) d = 0;
      this.inner(d / h);
      this.mid = this.$el.offsetHeight * 0.5 + "px";
    },
    setElement() {
      this.header = document.querySelector('header .bar');
      this.sec4 = document.querySelector('.sec4');
      this.sec4Content = this.sec4.querySelector('.j');
      this.scroll = this.sec4.querySelector('.scroll');
      this.itemText1 = this.sec4.querySelector('.copy .text1');
      this.itemText2 = this.sec4.querySelector('.copy .text2');
    },
    setElementSticky() {
      this.stickContainer = document.querySelector('.stick-container');
      this.stickCover = this.stickContainer.querySelector('.cover');
      this.stickScroll = this.stickContainer.querySelector('.scroll');
      this.stickSec4 = this.stickContainer.querySelector('.stick-container #sec4');
      this.copy = this.stickSec4.querySelector('.copy');
      this.itemText1 = this.stickSec4.querySelectorAll('.copy .text1');
      this.itemText2 = this.stickSec4.querySelectorAll('.copy .text2');
    },
    sticky(init) {
      if (init) {
        this.setElementSticky();
        this.copyFixed();
        responsive.addListener(this.resized);

        if (this.resize) {
          this.copyFixed();
        }
      } else {
        this.copyFixedReset();
      }
    },
    
    setStickyHeight() {
      const coverEl = document.querySelector('.cover2');
      const sec4Content = document.querySelector('.sec4 .j');

      if (coverEl !== null) {
        const coverElHeight = coverEl.offsetHeight;
        sec4Content.style.height = coverElHeight + 'px';
      }
    },
    copyFixed() {
      this.copy.classList.add('is-fixed');
    },
    copyFixedReset() {
      this.copy.classList.remove('is-fixed');
    },
    resized(section) {
      if (section.section !== 'sm') {
        this.setStickyHeight();

        const headerHeight = this.header.offsetHeight;
        this.space = headerHeight;
        this.resize = true;
        window.addEventListener('scroll', this.scrollMoveActive);

        if (section.section === 'xxl') {
          this.space = 900;
        }
      }
    },
  },
  beforeDestroy() {
    responsive.removeListener(this.resized);
  }
}
</script>

